var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sign-box"},[(_vm.mobile)?_c('canvas',{staticClass:"mobile",on:{"touchstart":_vm.touchstart,"touchmove":_vm.touchmove,"touchend":_vm.touchend}}):_c('canvas',{staticClass:"pc",on:{"mousedown":_vm.mousedown,"mousemove":_vm.mousemove,"mouseup":_vm.mouseup,"mouseout":_vm.mouseout}})])
}
var staticRenderFns = []

export { render, staticRenderFns }